module.exports = __webpack_public_path__ + "static/media/SF-15-A.50277984.mp3";